import { defineMessages } from "react-intl";

export default defineMessages({
    accessList: { id: "accesses.accessList", defaultMessage: "Access list", description: "Accesses: Access list" },
    globalAccessList: { id: "accesses.globalAccessList", defaultMessage: "Global access list", description: "Accesses: Global access list" },
    pleaseNoteItHasLimitation: {
        id: "accesses.pleaseNoteItHasLimitation",
        defaultMessage: "Please note it has limitation for services can be used for making traffic. CLI of services you can find at Other->OTP numbers",
        description: "Accesses: Please note it has limitation for services can be used for making traffic. CLI of services you can find at Other->OTP numbers"
    },
    limitsPerNumber: {
        id: "accesses.limitsPerNumber",
        defaultMessage: "Limits per number",
        description: "Accesses: Limits per number"
    },
    hourlyLimit: {
        id: "accesses.hourlyLimit",
        defaultMessage: "Hourly limit",
        description: "Accesses: Hourly limit"
    },
    dailyLimit: {
        id: "accesses.dailyLimit",
        defaultMessage: "Daily limit",
        description: "Accesses: Daily limit"
    },
    noCapacityAccesses: {
        id: "accesses.noCapacityAccesses",
        defaultMessage: "No capacity accesses",
        description: "Accesses filters: No capacity accesses"
    }
});